import sum from 'lodash/sum';
import { useCallback, useEffect } from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { inputBaseClasses } from '@mui/material/InputBase';
import InputAdornment from '@mui/material/InputAdornment';
// utils
import { fCurrency } from 'src/utils/format-number';
// _mock
import { _roles, INVOICE_SERVICE_OPTIONS, JOB_SKILL_OPTIONS, skillsOptions } from 'src/_mock';

// components
import Iconify from 'src/components/iconify';
import { RHFAutocomplete, RHFSelect, RHFTextField } from 'src/components/hook-form';
import { Checkbox, Chip, FormControl, InputLabel, OutlinedInput, Select } from '@mui/material';
import { useData } from 'src/contexts/gantt-chart/gantt-context';

// ----------------------------------------------------------------------

export default function CreateEditLabor({selectedActivity}) {
  const { control, setValue, watch, resetField } = useFormContext();
  const { dateWiseAssignData } = useData();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'items',
  });

  const values = watch();
  const totalOnRow = values.items.map((item) => item.quantity * item.price);
  const subTotal = sum(totalOnRow);
  const handleAdd = () => {
    append( {
      title: '',
      noOfPeople: '',
      noOfShifts: '',
      noOfDays: '',
      requiredHours: (selectedActivity.labor_hours/selectedActivity.duration).toFixed(2),
      totalHours: '',
      skillLevel: '',
      rate: '',
      amount: 0,
      name: [],
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };

  return (
    <Box sx={{ pt: 3 }}>
      <Stack divider={<Divider flexItem sx={{ borderStyle: 'dashed' }} />} spacing={3}>
        {fields.map((item, index) => (
          <Stack key={item.id} spacing={1.5}>
            <Stack
              gap={3}
              display="grid"
              gridTemplateColumns={{
                md: 'repeat(3, 1fr)',
                lg: 'repeat(5, 1fr)',
              }}
            >
              {/* <RHFTextField
                size="small"
                name={`items[${index}].title`}
                label="Title"
                InputLabelProps={{ shrink: true }}
              /> */}

              <RHFSelect
                name={`items[${index}].title`}
                size="small"
                label="Title"
                InputLabelProps={{ shrink: true }}
              >
                {dateWiseAssignData?.trade_worker_titles?.map((service) => (
                  <MenuItem key={service.id} value={service.id}>
                    {service.name}
                  </MenuItem>
                ))}
              </RHFSelect>
              <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].noOfPeople`}
                label="No Of People"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].noOfShifts`}
                label="No Of Shifs"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].noOfDays`}
                label="No Of Days"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                disabled
                size="small"
                type="number"
                name={`items[${index}].requiredHours`}
                label="Req Hrs"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].totalHours`}
                label="Total Hrs"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
              />
              <Stack>
             {dateWiseAssignData?.employees.length &&   <RHFAutocomplete
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  name={`items[${index}].name`}
                  placeholder="Employee Name"
                  label="Employee Name"
                  multiple
                  disableCloseOnSelect
                  options={
                   dateWiseAssignData?.employees?.map((option) => option)
                  }
                  getOptionLabel={(option) => option}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.first_name} {option.last_name}-{option?.trade_worker_title?.name}
                    </li>
                  )}
                  renderTags={(selected, getTagProps) =>
                    selected.map((option, index) => {
                      return (
                        <Chip
                          {...getTagProps({ index })}
                          key={option.id}
                          label={`${option.first_name} ${option.last_name}-${option?.trade_worker_title?.name ? option.trade_worker_title.name.slice(0, 5) + '...' : ''}
`}
                          size="small"
                          color="info"
                          variant="soft"
                        />
                      );
                    })
                  }
                />}
              </Stack>
              {/* <RHFSelect
                name={`items[${index}].employeeName`}
                size="small"
                label="Employee Name"
                InputLabelProps={{ shrink: true }}
              >
                {INVOICE_SERVICE_OPTIONS.map((service) => (
                  <MenuItem
                    key={service.id}
                    value={service.name}
                  >
                    {service.name}
                  </MenuItem>
                ))}
              </RHFSelect> */}
              <RHFSelect
                name={`items[${index}].skillLevel`}
                size="small"
                label="Skill Level"
                InputLabelProps={{ shrink: true }}
              >
                {skillsOptions.map((service) => (
                  <MenuItem key={service.value} value={service.value}>
                    {service.label}
                  </MenuItem>
                ))}
              </RHFSelect>
              {/* <RHFSelect
                name={`items[${index}].availability`}
                size="small"
                label="Availability"
                InputLabelProps={{ shrink: true }}
              >
                {INVOICE_SERVICE_OPTIONS.map((service) => (
                  <MenuItem key={service.id} value={service.name}>
                    {service.name}
                  </MenuItem>
                ))}
              </RHFSelect> */}
              <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].rate`}
                label="Rate"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                disabled
                size="small"
                type="number"
                name={`items[${index}].amount`}
                label="Amount"
                placeholder="0.00"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Box sx={{ typography: 'subtitle2', color: 'text.disabled' }}>$</Box>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  [`& .${inputBaseClasses.input}`]: {
                    textAlign: { md: 'right' },
                  },
                }}
              />
              {/* <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].price`}
                label="Price"
                placeholder="0.00"
                onChange={(event) => handleChangePrice(event, index)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Box sx={{ typography: 'subtitle2', color: 'text.disabled' }}>$</Box>
                    </InputAdornment>
                  ),
                }}
                sx={{ maxWidth: { md: 96 } }}
              /> */}
            </Stack>
            <Box display="flex" gap="30px" justifyContent="end">
              {fields.length - 1 == index && (
                <Button
                  size="small"
                  color="primary"
                  startIcon={<Iconify icon="mingcute:add-line" />}
                  onClick={handleAdd}
                  sx={{ flexShrink: 0 }}
                >
                  Add Item
                </Button>
              )}
           {fields.length > 0  && (  <Button
                size="small"
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemove(index)}
              >
                Remove
              </Button>)}
            </Box>
          </Stack>
        ))}
      </Stack>

      <Divider sx={{ my: 3, borderStyle: 'dashed' }} />
    </Box>
  );
}
